export default {
  methods: {
    copy(name, text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.$message({
        message: `Copy ${name} success!`,
        type: "success",
      });
    },
    openBlankPage(path) {
      let route = this.$router.resolve({ path: path });
      window.open(route.href, "_blank");
    },
  },
};
